/* Zentraler Katalog aller Zimmerbilder. Zimmerkarten (Rooms.jsx) und
   Aufgaben-Checklisten (RoomChecklist.jsx) teilen sich dieselbe Quelle. */
export const ROOM_IMAGES = {
  "Einzelzimmer": "https://customer-assets-4nw71qhi.emergentagent.net/job_management-hub-35/artifacts/a78onbnv_image.png",
  "Doppelzimmer": "https://customer-assets-4nw71qhi.emergentagent.net/job_management-hub-35/artifacts/66yka4vx_image.png",
  "Wohnzimmer":   "https://customer-assets-4nw71qhi.emergentagent.net/job_management-hub-35/artifacts/k3kcs9mh_image.png",
  "Apartment DG": "https://customer-assets-4nw71qhi.emergentagent.net/job_management-hub-35/artifacts/imocy9ot_image.png",
};

export const ROOM_FALLBACK_IMAGE =
  "https://mainspessartblick.de/wp-content/uploads/go-x/u/3d11a149-efe4-4b07-937d-a9398f8e5448/l0,t89,w2000,h1322/image-1366x903.jpg";

export const roomImage = (name) => ROOM_IMAGES[name] || ROOM_FALLBACK_IMAGE;
